import { ErrorCode as DropzoneErrorCode } from 'react-dropzone';

export const FILE_ERRORS_PRIORITY = [
  DropzoneErrorCode.FileInvalidType,
  DropzoneErrorCode.TooManyFiles,
  DropzoneErrorCode.FileTooLarge,
  DropzoneErrorCode.FileTooSmall,
];
